import { render } from "./HeroiconsOutlinePencilAlt.vue?vue&type=template&id=6624e093"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePencilAlt.vue"]])

export default __exports__